module.exports = __webpack_public_path__ + "static/img/warning.f000de8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hellocode-v2/warning.png
// module id = CjZh
// module chunks = 4 10